import { Api } from "./api"
import { GetMedicalModelsResult } from "./api.types"
import { getGeneralApiProblem } from "./api-problem"

export class MedicalModelApi {
  private api: Api

  constructor(api: Api) {
    this.api = api
  }
  
  async getAll() : Promise<GetMedicalModelsResult> {
    try {
      const response = await this.api.getMedicalModels()

      if (!response.ok) {
        const problem = getGeneralApiProblem(response)
        if (problem) return problem
      }

      const payload = response.data

      return { kind: 'ok', payload }
    } catch (e) {
      return { kind: "bad-data" }
    }
  }
}
